import { connect } from 'react-redux';

import * as bucketConstants from '../../constants/buckets';
import RemoveUser from '../../components/RemoveUser';

const mapDispatchToProps = dispatch => ({
    onSubmit: payload =>
        dispatch({
            type: bucketConstants.REMOVE_USERS_REQUEST,
            payload,
        }),
});

export default connect(
    undefined,
    mapDispatchToProps,
)(RemoveUser);



// WEBPACK FOOTER //
// ./src/containers/appDialog/RemoveUserFromBucket.js